import { render, staticRenderFns } from "./MemberTypeSelect.vue?vue&type=template&id=165b4a0d&scoped=true&"
import script from "./MemberTypeSelect.vue?vue&type=script&lang=js&"
export * from "./MemberTypeSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "165b4a0d",
  null
  
)

export default component.exports